import React from "react";
import {
  ORDER_FLOW_TYPE,
  ORDER_PHASE_CONTACTING,
  ORDER_PHASE_PREPARING,
  ORDER_TYPE_DELIVERY,
  PICKUP_STATUS,
} from "../../../constants";
import { getAddressFormatted, getShopFromOrder, formatPhoneWithPlus } from "../../../utils";
import { Box, Typography } from "@mui/material";
import renderOrderType from "../../Order/components/orderType";
import getStyles from "../OrderStatus.styles";

type OrderStatusAddressProps = {
  order: any;
};

export default function OrderStatusAddress({ order }: OrderStatusAddressProps) {
  const { address, orderType, pickupStatus } = order;
  const shop = getShopFromOrder(order);
  const { address: addressShop, name, support } = shop;
  const formattedPhone = formatPhoneWithPlus(support?.number);
  const styles = getStyles()
  const isContactingEmergency =
    order?.status === ORDER_PHASE_CONTACTING &&
    order?.selfPickupEligible &&
    order?.orderFlowType === ORDER_FLOW_TYPE.REVERSE &&
    pickupStatus === PICKUP_STATUS.ORDER_NOT_CURRENTLY_SUPPORTED;

  const isPreparingEmergency =
    order?.status === ORDER_PHASE_PREPARING &&
    order?.selfPickupEligible &&
    order.pickupStatus < PICKUP_STATUS.DRIVER_ON_THE_WAY_TO_RESTAURANT;

  const renderAddressBox = (label: string, value: string) => (
    <Box sx={styles.addressSection}>
      <Typography variant="caption" sx={{ fontWeight: 500 }}>{label}</Typography>
      <Typography variant="caption" sx={{ fontWeight: 400 }}>{value}</Typography>
    </Box>
  );

  return (
    <Box sx={styles.container}>
      <Box sx={{ ...styles.section, padding: "16px" }}>
        {renderOrderType(orderType, true)}
      </Box>
      <Box
        sx={{
          padding: "16px",
          alignItems: "flex-start",
          gap: 5,
          display: "flex",
          flexDirection: { md: "column", xl: "row" }
        }}

      >
        <Box
          sx={{
            ...styles.section,
            alignItems: "flex-start",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ flex: 1 }}>
            {renderAddressBox("Magasin :", name)}
          </Box>

          <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
            {orderType === ORDER_TYPE_DELIVERY &&
              !isContactingEmergency &&
              !isPreparingEmergency &&
              renderAddressBox(
                "Adresse de livraison :",
                getAddressFormatted(address)
              )}

            {orderType !== ORDER_TYPE_DELIVERY &&
              renderAddressBox(
                "Adresse du commerce :",
                getAddressFormatted(addressShop)
              )}
          </Box>

          <Box sx={{ flex: 1, display: "flex" }}>
            {renderAddressBox("Contact :", formattedPhone)}
          </Box>
        </Box>

      </Box>


    </Box>
  );
}
